export {
  type ToSignatureErrorType as ToEventSignatureErrorType,
  toSignature as toEventSignature,
} from './toSignature.js'
